
import { useState } from "react";
import { toast } from "sonner";
import LeadCaptureModal from "@/components/common/LeadCaptureModal";

export interface LeadCaptureOptions {
  onSuccess?: (lead: any, plan?: string) => void;
  title?: string;
  description?: string;
  source?: string;
}

export interface LeadFormData {
  name: string;
  email: string;
  phone: string;
}

export function useLeadCapture(options: LeadCaptureOptions = {}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<string | undefined>(undefined);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const openModal = (plan?: string) => {
    console.log('Abrindo modal de lead capture:', { plan, source: options.source });
    setSelectedPlan(plan);
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    console.log('Fechando modal de lead capture');
    setIsModalOpen(false);
    setSelectedPlan(undefined);
  };
  
  const handleSubmit = async (formData: LeadFormData) => {
    console.log('Processando lead capture:', { formData, selectedPlan, source: options.source });
    setIsSubmitting(true);
    
    try {
      // Callback de sucesso personalizado
      if (options.onSuccess) {
        options.onSuccess(formData, selectedPlan);
      }
    } catch (error: any) {
      console.error("Error processing lead:", error);
      toast.error("Erro ao processar dados", {
        description: "Por favor, tente novamente mais tarde."
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const LeadCaptureModalComponent = (
    <LeadCaptureModal
      isOpen={isModalOpen}
      onClose={closeModal}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      selectedPlan={selectedPlan}
      title={options.title}
      description={options.description}
      source={options.source}
    />
  );
  
  return {
    openLeadCapture: openModal,
    closeLeadCapture: closeModal,
    LeadCaptureModalComponent,
    isLeadCaptureOpen: isModalOpen
  };
}
